import React, { FC, PropsWithChildren, ReactNode } from 'react'
import { AppLayout } from '../../../components/layouts/AppLayout'
import { Locale } from '../../../common/intl/Locale'

interface Props extends PropsWithChildren {
  below?: ReactNode
  locales?: Locale[]
}

export const WebcamLayout: FC<Props> = ({ children, below, locales }) => {
  return (
    <AppLayout below={below} locales={locales}>
      {children}
    </AppLayout>
  )
}
